// General
import "./premium-empty-list.scss";
// Static Data
import routeConst from "../../../../../const/routeConst";
// Redux
import { useDispatch } from "react-redux";
import { updatePaymentTag } from "../../../../../redux/store/paymentStore";
// i18next
import { useTranslation } from "react-i18next";
// Custom Hooks
import useCustomNavigate from "../../../../utility/custom-hooks/useCustomNavigate-hook";
import IconManager from "../../../../utility/manager/icon-manager/icon-manager";

const PremiumEmptyList = () => {
  // Redux variables
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();
  const getIcon = IconManager();

  // Event Handlers | Button
  const onNavigateToUpgrade = () => {
    dispatch(updatePaymentTag("pwa-search-premium-sd-blocker"));
    onNavigate(routeConst.upgrade.path);
  };

  return (
    <div id="search-list-container-premium-empty-list-subcomponent">
      <div className="premium-empty-padding-container">
        <div className="empty-premium-list-image-container">
          {getIcon("premiumLockIcon", "empty-premium-list-image")}
        </div>

        <div className="title">{t("search.premium_locked_title")}</div>

        <div className="description">{t("search.premium_locked_sbf_desc")}</div>

        <div className="upgrade-now-button" onClick={onNavigateToUpgrade}>
          {t("profile.upgrade_now")}
        </div>

        <div className="foot-note">{t("search.premium_locked_sbf_note")}</div>
      </div>
    </div>
  );
};

export default PremiumEmptyList;
